import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsAccordionDescription',
  setup(__props) {

const pdpDetails = inject('pdpDetails') as any;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "product-details-accordion-description",
    innerHTML: _unref(pdpDetails)?.description?.productDescription
  }, null, 8, _hoisted_1))
}
}

})